import PropTypes from 'prop-types';

import SimplePlanLogo from '../../../images/simple-plan-logo-black.svg';
import LoadingOverlay from '../../LoadingOverlay';
import useWorkspaceInvite from '../../../context/WorkspaceInviteContext';

const AuthUserTemplate = (props) => {
  const { isInviteVerifying } = useWorkspaceInvite();
  const { children, isLoading = false, showTAndC = false, loginStep } = props;

  return (
    <div className="workspace-login-container">
      <LoadingOverlay open={isLoading} />
      {
        !isInviteVerifying && loginStep &&
        <div className="login-card">
          <img width={210} height={48} src={SimplePlanLogo} alt="Simple Plan Logo" />
          {children}
        </div>
      }
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      {showTAndC && !isInviteVerifying && loginStep && <span className="tnc-text">By continuing, you&apos;re agreeing to our <a href="#">User Terms of Service </a></span>}
    </div>
  );
};

AuthUserTemplate.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  showTAndC: PropTypes.bool,
  loginStep: PropTypes.symbol,
};

export default AuthUserTemplate;
